///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.brand_promos = abcsetup.brand_promos || {};
abcsetup.brand_promos.common = abcsetup.brand_promos.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////

abcsetup.brand_promos.common = {

    currentCampaignTypeId: null,
    campaignStates: {},
    availableCampaignQuantities: {},
    selectedDatesCount: {},
    restrictedDates: [],
    reservedDatesWithReasons: [],
    businessHours: [],
    shouldUseBusinessHours: [],
    campaignType: null,
    campaignPeriod: null,
    existingCampaignPeriods: [],
    maxSuppliers: 0,

    withinBusinessHours: function(date, type_id){
        if(!abcsetup.brand_promos.common.shouldUseBusinessHours[type_id] || !Object.keys(abcsetup.brand_promos.common.businessHours[type_id]).length){
            return true;
        }
        return abcsetup.brand_promos.common.businessHours[type_id].daysOfWeek.includes(moment(date).day());
    },

    recalculateSelectedDatesCount: function() {
        // Reset selectedDatesCount to start fresh
        abcsetup.brand_promos.common.selectedDatesCount = {};

        $('.campaign-start-date, .additional-campaign-date').each(function() {
            const dateValue = $(this).val();
            if (dateValue) {
                // Increment the count for each date value found
                abcsetup.brand_promos.common.selectedDatesCount[dateValue] =
                    (abcsetup.brand_promos.common.selectedDatesCount[dateValue] || 0) + 1;
            }
        });

        // Log the updated selectedDatesCount
        console.log('Updated selectedDatesCount:', abcsetup.brand_promos.common.selectedDatesCount);
    },

    checkDateWithinPeriodAndMax: function(startMoment) {
        let endMoment;

        // If maxSuppliers is 0, there's no limit on campaigns, so return false immediately
        if (abcsetup.brand_promos.common.maxSuppliers === 0) {
            return false;
        }

        // Determine the period end based on campaignPeriod
        if (abcsetup.brand_promos.common.campaignPeriod === "monthly") {
            endMoment = startMoment.clone().endOf('month');
        } else if (abcsetup.brand_promos.common.campaignPeriod) {
            endMoment = startMoment.clone().add(abcsetup.brand_promos.common.campaignPeriod - 1, 'days'); // Include the start date
        } else {
            endMoment = startMoment; // No period, just the date itself
        }

        console.log('Checking period for new date from:', startMoment.format('YYYY-MM-DD'), 'to:', endMoment.format('YYYY-MM-DD'));

        // Calculate total campaigns that fall within any conflicting period
        let totalCampaignsInConflictPeriod = 0;

        Object.keys(abcsetup.brand_promos.common.selectedDatesCount).forEach(existingDate => {
            const existingStartMoment = moment(existingDate, 'YYYY-MM-DD');
            let existingEndMoment;

            // Calculate the end of the period for each existing date
            if (abcsetup.brand_promos.common.campaignPeriod === "monthly") {
                existingEndMoment = existingStartMoment.clone().endOf('month');
            } else if (abcsetup.brand_promos.common.campaignPeriod) {
                existingEndMoment = existingStartMoment.clone().add(abcsetup.brand_promos.common.campaignPeriod - 1, 'days');
            } else {
                existingEndMoment = existingStartMoment;
            }

            // Check if the new date's period overlaps with this existing date's period
            if (
                startMoment.isBetween(existingStartMoment, existingEndMoment, null, '[]') ||
                endMoment.isBetween(existingStartMoment, existingEndMoment, null, '[]') ||
                existingStartMoment.isBetween(startMoment, endMoment, null, '[]') ||
                existingEndMoment.isBetween(startMoment, endMoment, null, '[]')
            ) {
                // Add the count of this date to the total campaigns in the conflict period
                totalCampaignsInConflictPeriod += abcsetup.brand_promos.common.selectedDatesCount[existingDate];
            }
        });

        console.log('Total campaigns in conflict period:', totalCampaignsInConflictPeriod);
        console.log('Max suppliers allowed:', abcsetup.brand_promos.common.maxSuppliers);

        // If the count in any overlapping period meets or exceeds max suppliers, we have a conflict
        if (totalCampaignsInConflictPeriod > abcsetup.brand_promos.common.maxSuppliers) {
            alert(`The selected date falls within an existing period that has reached the maximum campaign limit of ${abcsetup.brand_promos.common.maxSuppliers}. Please choose another date.`);
            return true;
        }

        return false;
    },

    bindFormElems: function () {
        $(".campaign_type").on("change", function () {
            let $this = $(this);
            let newCampaignTypeId = $this.val();

            // Save the state of the previous campaign before switching
            if (abcsetup.brand_promos.common.currentCampaignTypeId) {
                abcsetup.brand_promos.common.saveCurrentCampaignState(abcsetup.brand_promos.common.currentCampaignTypeId);
            }

            // Set the new campaign type ID globally
            abcsetup.brand_promos.common.currentCampaignTypeId = newCampaignTypeId;

            let $target = $($this.data("target"));
            if ($this.is(':checked')) {
                abcsetup.blockUI(true);

                axios.post('/api/brand_promos/get_campaign_options', { campaign_type_id: newCampaignTypeId })
                    .then((response) => {
                        if (response.data) {
                            $target.html(response.data.data);
                            $target.find('input').data('campaign-type-id', newCampaignTypeId);
                            $('select[name$="reserved_date_override"]').hide();
                            $('input[name$="request_restricted_date"]').hide();
                            if (!abcsetup.brand_promos.common.availableCampaignQuantities[newCampaignTypeId]) {
                                abcsetup.brand_promos.common.availableCampaignQuantities[newCampaignTypeId] = {};
                            }
                            abcsetup.brand_promos.common.restrictedDates[$this.val()] = response.data.restrictedDates;
                            abcsetup.brand_promos.common.reservedDatesWithReasons[$this.val()] = response.data.reservedDatesWithReasons;
                            abcsetup.brand_promos.common.businessHours[$this.val()] = response.data.businessHours;
                            abcsetup.brand_promos.common.shouldUseBusinessHours[$this.val()] = response.data.shouldUseBusinessHours;
                            abcsetup.brand_promos.common.existingCampaignPeriods[$this.val()] = response.data.existingCampaignPeriods;
                            abcsetup.brand_promos.common.campaignPeriod = response.data.campaignPeriod;
                            abcsetup.brand_promos.common.campaignType = newCampaignTypeId;
                            abcsetup.brand_promos.common.maxSuppliers = response.data.maxSuppliers;
                            $('#app_models_brand_promo_campaign_advertisement_advertisement_ad_campaign_comments').closest('div.form-group').hide();

                            for (const date in response.data.availableCampaignQuantities) {
                                abcsetup.brand_promos.common.availableCampaignQuantities[newCampaignTypeId][date] =
                                    response.data.availableCampaignQuantities[date] === null ? null : response.data.availableCampaignQuantities[date];
                            }
                            $('#app_models_brand_promo_campaign_advertisement_advertisement_ad_campaign_comments').closest('div.form-group').hide();
                            $target.collapse('show'); // append the form to the page

                            abcsetup.brand_promos.common.restoreCampaignState(newCampaignTypeId);
                        }
                        abcsetup.unblockUI();
                    })
                    .catch((error) => {
                        abcsetup.unblockUI();
                    });
            } else {
                $target.html("");
                $target.collapse('hide');
            }
        });

        $(document).on("change", 'input[name$=quantity], input[name$=campaign_start_date], .additional-campaign-date', function () {
            let $this = $(this);
            let campaign_type_id = $this.data('campaign-type-id');
            if (!campaign_type_id) {
                campaign_type_id = $this.closest('[data-campaign-type-id]').data('campaign-type-id');
            }

            let container = $this.closest('div[data-campaign-type-id]');

            if ($this.is('input[name$=quantity]')) {
                container.find('select[name$="reserved_date_override"], label.custom-label').remove();
            }

            // Retrieve the campaignQuantityInput and campaignQuantity
            let campaignQuantityInput = container.find('input[name$=quantity]');
            let campaignQuantity = parseInt(campaignQuantityInput.val(), 10);

            // Retrieve campaignDate and startMoment based on the input that was changed
            let campaignDate = $('div[data-campaign-type-id='+campaign_type_id+']').find('input[name$=campaign_start_date]').val();
            let startMoment = moment(campaignDate);

            let reservedDateOverride = $('div[data-campaign-type-id='+campaign_type_id+']').find('select[name$="reserved_date_override"]');
            let customLabel = reservedDateOverride.prev('label.custom-label');

            let index = $this.data('index') || '';

            // abcsetup.brand_promos.toggleReservedDateOverride(containerId, index, false);
            if (reservedDateOverride.length === 0) {
                reservedDateOverride = $this.closest('.additional-start-date-container').find(`select[data-index="${index}"]`);
                if (customLabel.length === 0) {
                    customLabel = $this.closest('.additional-start-date-container').find('label.custom-label');
                }
            }

            reservedDateOverride.hide();
            customLabel.hide();

            campaignQuantityInput.css('border', '');
            $('label.error-message').remove();

            if ($this.hasClass('additional-campaign-date') || $this.val() == $('div[data-campaign-type-id='+campaign_type_id+']').find('input[name$=campaign_start_date]')) {
                startMoment = moment($this.val());
            }

            // If both campaignQuantity and startMoment are valid, proceed with checks
            if (campaignQuantity && startMoment.isValid()) {
                abcsetup.brand_promos.common.executeChecks($this, campaign_type_id, startMoment, reservedDateOverride, customLabel);
            }
        });

        // Event handler for "ad campaign divisions" input changes
        $(document).on("change", 'input[name="ad_campaign_divisions[]"]', function () {
            let $this = $(this);
            let isOtherChecked = $this.is(':checked') && $this.val() === 'Other';
            let commentsWrapper = $('#app_models_brand_promo_campaign_advertisement_advertisement_ad_campaign_comments').closest('div.form-group');

            if (isOtherChecked) {
                commentsWrapper.show();
                commentsWrapper.find('textarea').prop('required', true);
            } else {
                if (!$('input[name="ad_campaign_divisions[]"]:checked').filter(function () {
                    return $(this).val() === 'Other';
                }).length) {
                    commentsWrapper.hide();
                    commentsWrapper.find('textarea').prop('required', false).val('');
                }
            }
        });

        // Reserved date override is used to remove an existing reserved date and replace with the current campaign
        $(document).on("change", 'select[name$="reserved_date_override"], .reserved-date-override', function() {
            let reservedDateOverrideValue = $(this).val();
            let dateField = $(this).closest('div[data-campaign-type-id]').find('input[name$="campaign_start_date"], .additional-campaign-date');

            if (reservedDateOverrideValue === "0") {
                dateField.val('').focus();
                $(this).hide();
                let customLabel = $(this).prev('label.custom-label');
                if (customLabel.length) {
                    customLabel.hide();
                }
            } else if (reservedDateOverrideValue === "1") {
                $(this).hide();
                let customLabel = $(this).prev('label.custom-label');
                if (customLabel.length) {
                    customLabel.hide();
                }
            }
        });

        // Watch for changes to the 'qty' field and add desired start date fields
        $(document).on("change", 'input[name$=quantity]', function () {

            let $this = $(this);
            let campaign_type_id = $this.data('campaign-type-id');
            let campaignContainer = $(`div[data-campaign-type-id=${campaign_type_id}]`);
            let qty = parseInt($this.val(), 10) || 0;

            // Clear any existing date values in the current date picker fields
            campaignContainer.find('.campaign-start-date, .additional-campaign-date').each(function() {
                $(this).val('');
            });

            // Remove the original start date field and related elements if qty is greater than 1
            if (qty > 1) {
                campaignContainer.find('label[for$="campaign_start_date"]').remove();
                campaignContainer.find('input[name$="campaign_start_date"]').remove();
                campaignContainer.find('small.form-text').filter(function() {
                    return $(this).text().includes("Campaign end date will be set automatically based on the campaign type.");
                }).remove();
                campaignContainer.find('select[name$="reserved_date_override"]').remove();
                campaignContainer.find('div.checkbox.form-group.row.mb-0.mt-1').has('label:contains("Request Restricted Date")').remove();

                // Add the correct number of desired start date fields based on the qty
                abcsetup.brand_promos.common.addDesiredStartDateFields(campaignContainer, qty);
            } else if (qty === 1) {
                // If qty is set back to 1, add a single desired start date field to replace the original
                abcsetup.brand_promos.common.addDesiredStartDateFields(campaignContainer, 1);
            } else {
                // If qty is zero or invalid, remove all added fields
                campaignContainer.find('.additional-start-date-container').remove();
            }
        });
    },

    // Save the current state of the campaign before switching to a new campaign type
    saveCurrentCampaignState: function(campaignTypeId) {
        if (!campaignTypeId) {
            console.warn('No campaign type ID passed to saveCurrentCampaignState.');
            return;
        }

        let campaignContainer = $('div[data-campaign-type-id=' + campaignTypeId + ']');

        if (campaignContainer.length > 0) {
            let quantity = campaignContainer.find('input[name$=quantity]').val();
            let startDate = campaignContainer.find('input[name$=campaign_start_date]').val();

            abcsetup.brand_promos.common.campaignStates[campaignTypeId] = {
                quantity: quantity || '',
                startDate: startDate || ''
            };
        }
    },

    // Restore the state of the campaign when switching back to a previously selected campaign type
    restoreCampaignState: function(campaignTypeId) {
        if (abcsetup.brand_promos.common.campaignStates[campaignTypeId]) {
            let savedState = abcsetup.brand_promos.common.campaignStates[campaignTypeId];
            let campaignContainer = $('div[data-campaign-type-id=' + campaignTypeId + ']');

            if (campaignContainer.length > 0) {
                campaignContainer.find('input[name$=quantity]').val(savedState.quantity);
                campaignContainer.find('input[name$=campaign_start_date]').val(savedState.startDate);
            }
        }
    },

    // Execute all checks for the selected campaign type to ensure the selected date is valid and available
    executeChecks: function($this, campaign_type_id, startMoment, reservedDateOverride, customLabel) {
        const formattedDate = startMoment.format('YYYY-MM-DD');

            // Skip checks if the field is empty or set to today's date (default value).
        if (!formattedDate || formattedDate === moment().format('YYYY-MM-DD')) {
            console.log('Skipping checks as the date is empty or set to today by default.');
            return;
        }

        if (!startMoment || !moment(startMoment).isValid()) {
            console.log('startMoment not valid', startMoment);
            return;
        }

        if (startMoment.year() < 1900) return false;

        if (moment().diff(startMoment, 'days') > 0) {
            alert("Start date must be in the future.");
            $this.val('').focus();
            return;
        }

        // Run the recalculation function to update selectedDatesCount
        abcsetup.brand_promos.common.recalculateSelectedDatesCount();

        // Check if the selected date conflicts with the period and max suppliers
        if (abcsetup.brand_promos.common.checkDateWithinPeriodAndMax(startMoment)) {
            $this.val('').focus();
            return;
        }

        const reservedDates = abcsetup.brand_promos.common.reservedDatesWithReasons[campaign_type_id];
        const reservedDateInfo = reservedDates[startMoment.format('YYYY-MM-DD')] || null;
        const availableCampaignQuantitiesForDate = abcsetup.brand_promos.common.availableCampaignQuantities[campaign_type_id]?.[startMoment.format('YYYY-MM-DD')];

        let totalAvailableCampaigns;

        // Calculate the total available campaigns for the selected date if the campaign does has a max limit
        if (availableCampaignQuantitiesForDate != null) {
            totalAvailableCampaigns = availableCampaignQuantitiesForDate + (reservedDateInfo ? parseInt(reservedDateInfo.quantity, 10) : 0);
        }

        // Check if the selected date has more campaigns than the total available including the reserved date
        if (reservedDateInfo && abcsetup.brand_promos.common.selectedDatesCount[formattedDate] > totalAvailableCampaigns) {
            let campaignQuantityInput = $this.closest('div[data-campaign-type-id]').find('input[name$=quantity]');
            campaignQuantityInput.css('border', '1px solid red');

            let errorMessage = `Only ${totalAvailableCampaigns} campaigns are allowed.`;
            let errorLabel = $('<label>', {
                text: errorMessage,
                class: 'error-message',
                style: 'color: red; display: block; margin-top: 5px; font-size: 12px;'
            });
            campaignQuantityInput.after(errorLabel);

            alert(`All campaigns are full for this date. Please select another date.`);
            $this.val('').focus();
        } else {
            $this.css('border', '');
            $('label.error-message').remove();
        }

        // Check if the selected date has more campaigns than the available quantity but has a reserved date that can be overridden and used
        if (reservedDateInfo && abcsetup.brand_promos.common.selectedDatesCount[formattedDate] > availableCampaignQuantitiesForDate) {
            let labelText = reservedDateInfo.reason
                ? `This date ${startMoment.format('MM/DD/YYYY')} is already reserved for ${reservedDateInfo.reason}. Only ${availableCampaignQuantitiesForDate} campaign(s) are available. Do you want to fill the reserved date with this campaign?`
                : `This date ${startMoment.format('MM/DD/YYYY')} is already reserved. Only ${availableCampaignQuantitiesForDate} campaign(s) are available. Do you want to fill the reserved date with this campaign?`;

            customLabel = $('<label>', {
                for: `${reservedDateOverride.attr('id')}_custom`,
                class: 'custom-label',
                style: 'color: #ff0000',
                text: labelText
            });

            reservedDateOverride.val('').show();
            reservedDateOverride.before(customLabel);
        } else if (abcsetup.brand_promos.common.selectedDatesCount[formattedDate] > availableCampaignQuantitiesForDate) {
            if (availableCampaignQuantitiesForDate === 0) {
                alert(`All campaigns are full for this date. Please select another date.`);
                $this.val('').focus();
            } else {
                alert(`Only ${availableCampaignQuantitiesForDate} campaign(s) are available for this date. Please enter a quantity less than or equal to ${availableCampaignQuantitiesForDate}.`);
                $this.val('').focus();
            }
        } else {
            // Find the associated restricted date checkbox
            const associatedRestrictedDateCheckbox = $this.closest('.additional-start-date-container').find('input[name$="request_restricted_date"]');

            // Only proceed with availability and business hours check if `request_restricted_date` is not checked
            if (!associatedRestrictedDateCheckbox.is(':checked')) {

                // Add check for restricted dates
                if (formattedDate in reservedDates) {
                    alert(`${startMoment.format('l')} is restricted. Please choose another date.`);
                    abcsetup.brand_promos.common.selectedDatesCount[formattedDate]--;
                    $this.val('').focus();
                    return;
                }

                // Check business hours if applicable
                if (!abcsetup.brand_promos.common.withinBusinessHours(startMoment, campaign_type_id)) {
                    alert(`${startMoment.format('l')} is outside campaign availability. Please select another date.`);
                    abcsetup.brand_promos.common.selectedDatesCount[formattedDate]--;
                    $this.val('').focus();
                    return;
                }
            }
        }
    },

    // Add additional desired start date fields based on the quantity
    addDesiredStartDateFields: function (campaignContainer, qty) {
        // Reset selectedDatesCount to handle new fields correctly
        abcsetup.brand_promos.common.selectedDatesCount = {};

        // Remove any existing additional start date fields
        campaignContainer.find('.additional-start-date-container').remove();

        let containerId = campaignContainer.attr('id');

        // Create new fields based on the qty
        for (let i = 1; i <= qty; i++) {
            let inputType = (containerId === 'advertisement') ? 'month' : 'date'; // Set the input type to month for advertisement campaigns
            // let index = i === 1 ? '' : `_${i}`;
            let index = i;
            let labelText = i === 1 ? 'Desired Start Date' : `Desired Start Date ${i}`;
            let firstFieldStyle = i === 1 ? ' style="position: relative; margin-top: -5%;"' : '';
            let startDateFieldHTML = `
                <div class="row mb-5 ml-1 additional-start-date-container" ${firstFieldStyle}>
                    <div class="col-12 col-sm-6 col-md-3">
                        <label for="app_models_brand_promo_${containerId}_campaign_start_date${index}">${labelText}</label>
                        <input type="${inputType}"
                            class="form-control col-sm-11 campaign-start-date additional-campaign-date"
                            id="app_models_brand_promo_${containerId}_campaign_start_date${index}"
                            name="${containerId}_campaign_start_date${index}"
                            value=""
                            data-index="${index}">
                        <small class="form-text text-muted" style="font-size: 0.75rem; display: block; width: 95%;">Campaign end date will be set automatically based on the campaign type.</small>

                        <label for="app_models_brand_promo_${containerId}_reserved_date_override${index}" class="custom-label error-message" style="color: #ff0000; display: none;" data-index="${index}"></label>
                        <select class="form-control form-select col-sm-12 reserved-date-override"
                            id="app_models_brand_promo_${containerId}_reserved_date_override${index}"
                            name="${containerId}_reserved_date_override${index}"
                            data-index="${index}"
                            style="display: none;">
                            <option value="">- select -</option>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>

                        <div class="form-check mt-4">
                            <input type="checkbox"
                                class="form-check-input"
                                id="app_models_brand_promo_${containerId}_request_restricted_date${index}"
                                name="${containerId}_request_restricted_date${index}"
                                style="transform: scale(1.5); border: 1px solid #ced4da; background-color: #ffffff; border-radius: 0.15rem; transition: border-color 0.15s ease-in-out;"
                                data-index="${index}">
                            <label class="form-check-label ml-1"
                                for="app_models_brand_promo_${containerId}_request_restricted_date${index}">Request Restricted Date</label>
                        </div>
                    </div>
                </div>
            `;

            // Add the new fields to the campaign container
            campaignContainer.append(startDateFieldHTML);
        }

        let addedFields = campaignContainer.find('.additional-campaign-date');

        // Add event listener to the new fields
        addedFields.on('change', function () {
            let $this = $(this);
            let startMoment = moment($this.val());
            let campaign_type_id = $this.data('campaign-type-id');

            if (!campaign_type_id) {
                campaign_type_id = $this.closest('[data-campaign-type-id]').data('campaign-type-id');
            }

            let campaignQuantityInput = campaignContainer.find('input[name$=quantity]');
            let campaignQuantity = parseInt(campaignQuantityInput.val(), 10);

            let reservedDateOverride = $this.closest('.additional-start-date-container').find('.reserved-date-override');
            let customLabel = reservedDateOverride.prev('.custom-label');

            // Run executeChecks with the new start date value added to ensure new fields are validated
            if (campaignQuantity && startMoment.isValid()) {
                abcsetup.brand_promos.common.executeChecks($this, campaign_type_id, startMoment, reservedDateOverride, customLabel);
            }
        });
    },
}